/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System View History Icon component.
 */
export const SystemViewHistoryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.47021 10.0915C3.98088 7.96352 5.22945 6.08556 6.99402 4.79128C8.75859 3.49701 10.9249 2.87025 13.1079 3.02239C15.291 3.17454 17.3494 4.09571 18.9174 5.62225C20.4854 7.14878 21.4614 9.18178 21.6719 11.36C21.8825 13.5382 21.314 15.7205 20.0674 17.5191C18.8209 19.3177 16.977 20.6161 14.8635 21.1836C12.75 21.7511 10.5038 21.5508 8.52399 20.6185C6.54418 19.6862 4.95903 18.0822 4.05023 16.0915' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M12.0601 9V13.64L15.2701 15.99' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M6.5 10.49L3.14 10.85L2 8' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default SystemViewHistoryIcon;
